import { createRegistry } from "@/lib/content/registry";

// CRM content registry.
// To add a CRM page: create a file in ./features (or ./solutions), import it
// here, and add it to the array below. The /crm-software catch-all route does
// the rest (URL, SEO, rendering, sitemap).
import { salesforceAutomation } from "./features/salesforce-automation";
import { leadManagement } from "./features/lead-management";
import { dealManagement } from "./features/deal-management";
import { contactManagement } from "./features/contact-management";
import { accountManagement } from "./features/account-management";
import { workflowManagement } from "./features/workflow-management";
import { cadences } from "./features/cadences";
// Process Management hub + sub-features
import { processManagement } from "./features/process-management";
import { salesBlueprint } from "./features/sales-blueprint";
import { leadScoring } from "./features/lead-scoring";
import { approvalProcess } from "./features/approval-process";
import { assignmentRule } from "./features/assignment-rule";
import { reviewProcess } from "./features/review-process";
import { validationRule } from "./features/validation-rule";
import { multiPageLayout } from "./features/multi-page-layout";
// Omni Channels hub + sub-features
import { omniChannels } from "./features/omni-channels";
import { email } from "./features/email";
import { telephony } from "./features/telephony";
import { socialMedia } from "./features/social-media";
import { sms } from "./features/sms";
import { whatsapp } from "./features/whatsapp";
import { liveChat } from "./features/live-chat";
import { webforms } from "./features/webforms";
// CRM Analytics hub + sub-features
import { crmAnalytics } from "./features/crm-analytics";
import { reports } from "./features/reports";
import { charts } from "./features/charts";
import { cohorts } from "./features/cohorts";
import { kpis } from "./features/kpis";
import { funnels } from "./features/funnels";
// Sales Performance hub + sub-features
import { salesPerformance } from "./features/sales-performance";
import { forecasting } from "./features/forecasting";
import { multipleCurrencies } from "./features/multiple-currencies";
import { salesAnalytics } from "./features/analytics";
import { visitorTracking } from "./features/visitor-tracking";
// Sales Enablement hub + sub-features
import { salesEnablement } from "./features/sales-enablement";
import { finance } from "./features/finance";
import { configurePriceQuote } from "./features/configure-price-quote";
import { documentsLibrary } from "./features/documents-library";
import { calendar } from "./features/calendar";
import { salesInbox } from "./features/salesinbox";
import { zoomMeetingIntegration } from "./features/zoom-meeting-integration";
import { alertAndNotification } from "./features/alert-and-notification";

export const crmContent = createRegistry(
  [
    // Salesforce Automation
    salesforceAutomation,
    leadManagement,
    dealManagement,
    contactManagement,
    accountManagement,
    workflowManagement,
    cadences,
    // Process Management
    processManagement,
    salesBlueprint,
    leadScoring,
    approvalProcess,
    assignmentRule,
    reviewProcess,
    validationRule,
    multiPageLayout,
    // Omni Channels
    omniChannels,
    email,
    telephony,
    socialMedia,
    sms,
    whatsapp,
    liveChat,
    webforms,
    // CRM Analytics
    crmAnalytics,
    reports,
    charts,
    cohorts,
    kpis,
    funnels,
    // Sales Performance
    salesPerformance,
    forecasting,
    multipleCurrencies,
    salesAnalytics,
    visitorTracking,
    // Sales Enablement
    salesEnablement,
    finance,
    configurePriceQuote,
    documentsLibrary,
    calendar,
    salesInbox,
    zoomMeetingIntegration,
    alertAndNotification,
  ],
  { basePath: "/crm-software" }
);
